import { Component, OnInit, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import {
  UntypedFormBuilder,
  Validators,
  UntypedFormGroup,
  UntypedFormControl,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatFormField, MatLabel, MatSuffix, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import {
  MatDatepickerInput,
  MatDatepickerToggle,
  MatDatepicker,
} from '@angular/material/datepicker';
import { MatSelect, MatOption } from '@angular/material/select';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatButton } from '@angular/material/button';

export interface DialogData {
  type?: string;
  onlyExport?: boolean;
}

export type UserExportSelection = 'all' | 'current' | 'filtered';

@Component({
  selector: 'app-import-export',
  templateUrl: './import-export.component.html',
  styleUrls: ['./import-export.component.scss'],
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatRadioGroup,
    MatRadioButton,
    MatFormField,
    MatLabel,
    MatInput,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatSuffix,
    MatDatepicker,
    MatError,
    MatSelect,
    MatOption,
    MatSlideToggle,
    MatDialogActions,
    MatButton,
    MatDialogClose,
  ],
})
export class ImportExportComponent implements OnInit {
  selectedOption = { name: 'Exporteren', value: 'Export' };
  options: any[] = [
    { name: 'Exporteren', value: 'Export', checked: true },
    { name: 'Importeren', value: 'Import', checked: false },
  ];
  exportImportForm: UntypedFormGroup = this.fb.group({
    type: [this.selectedOption.value, Validators.required],
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ImportExportComponent>,
    private fb: UntypedFormBuilder,
  ) {}

  ngOnInit() {
    this.exportImportForm.controls.type.valueChanges.subscribe((changed) => {
      if (changed.value === 'Export') {
        this.selectedOption = { name: 'Exporteren', value: 'Export' };
      } else {
        this.selectedOption = { name: 'Importeren', value: 'Import' };
      }
    });

    if (this.data?.type === 'rides') {
      this.exportImportForm.addControl(
        'startFrom',
        new UntypedFormControl(
          new Date(new Date().setMonth(new Date().getMonth() - 1)),
          Validators.required,
        ),
      );
    }

    if (this.data?.type === 'users' || this.data?.type === 'admin-users') {
      this.exportImportForm.addControl(
        'usersToExport',
        new UntypedFormControl('all' as UserExportSelection, Validators.required),
      );
    }

    if (this.data?.type === 'audits') {
      this.exportImportForm.addControl('showTime', new UntypedFormControl(false));
    }
  }

  save() {
    const saveObj = {
      type: this.selectedOption.value,
    } as any;
    if (this.data?.type === 'rides') {
      saveObj.startFrom =
        this.exportImportForm.value.startFrom ??
        new Date(new Date().setMonth(new Date().getMonth() - 1));
    }
    if (this.data?.type === 'users' || this.data?.type === 'admin-users') {
      saveObj.usersToExport = this.exportImportForm.value.usersToExport;
    }
    if (this.data?.type === 'audits') {
      saveObj.showTime = this.exportImportForm.value.showTime;
    }
    this.dialogRef.close(saveObj);
  }
}
